<template lang="pug">
  section.grey.lighten-3()
    v-tabs(fixed-tabs dark background-color='primary', slider-color='white' color='white')
      v-tab
        .white--text.font-weight-bold() Vehicles
      v-tab-item
        v-text-field.grey.lighten-3.pa-4(append-icon='search', hide-details label='Search Vehicle', text)
        .SideBarFilter.grey.lighten-3.pa-4
          v-menu(bottom left)
            template(#activator="{ on }")
              v-btn(outlined small v-on="on", color='primary')
                span {{ sortBy }}
                v-icon.tripFilter(large) arrow_drop_down
            v-list(dense)
              v-list-item(v-for='(item, i) in items', :key='i', @click='onSortBy(item.title)')
                v-list-item-title {{ item.title }}
          v-icon filter_list
        //-  Moving Drivers
        div(v-show="movingDrivers.length")
          trip-sidebar-divider(label="", :isOpen='isMovingClosed', :count="movingDrivers.length", v-on:close='onClose')
          .scrollSideBar(:style="{'height':`${height-15}px`}")
            trip-vehicle-item(v-if="movingDevices.length > 0" v-for="item in movingDevices", :key='item.id', :item="item"  status="MOVING")
        
      v-tab
        .white--text.font-weight-bold() Drivers
      v-tab-item
      
        v-text-field.grey.lighten-3.pa-4(append-icon='search', hide-details label='Search Driver', text)
        .SideBarFilter.grey.lighten-3.pa-4
          v-menu(bottom left)
            template(#activator="{ on }")
              v-btn(outlined small v-on="on", color='primary')
                span {{ sortBy }}
                v-icon.tripFilter(large) arrow_drop_down
            v-list(dense)
              v-list-item(v-for='(item, i) in items', :key='i', @click='onSortBy(item.title)')
                v-list-item-title {{ item.title }}
          v-icon filter_list
        //-  Moving Drivers
        div(v-show="movingDrivers.length")
          trip-sidebar-divider(label="MOVING", :isOpen='isMovingClosed', :count="movingDrivers.length", v-on:close='onClose')
          .scrollSideBar(:style="{'height':`${height-15}px`}")
            trip-driver-item(v-if="isMovingClosed" v-for="item in movingDrivers", :key='item.id', :item="item"  status="MOVING")

        //- // Stopped Drivers
        //- div(v-show='stoppedDrivers.length')
        //-   trip-sidebar-divider(label="STOPPED", :isOpen='isStoppedClosed', :count='stoppedDrivers.length', v-on:close='onClose')
        //-   trip-driver-item(v-show='isStoppedClosed', v-for='driver in stoppedDrivers', :key='driver.id', :imageURL='driver.imageURL', :direction='driver.direction', :time='driver.time', :distance='driver.distance', :name='driver.name', :registration='driver.registration', :status="'STOPPED'")
        //- // Inactive Drivers
        //- div(v-show='inactiveDrivers.length')
        //-   trip-sidebar-divider(label="INACTIVE", :isOpen='isInactiveClosed', :count='inactiveDrivers.length', v-on:close='onClose')
        //-   trip-driver-item(v-show='isInactiveClosed', v-for='driver in inactiveDrivers', :key='driver.id', :imageURL='driver.imageURL', :direction='driver.direction', :time='driver.time', :distance='driver.distance', :name='driver.name', :registration='driver.registration', :status="'INACTIVE'")



  </template>

<script>
import TripSidebarDivider from "@/modules/maps/components/ui/SideBar/TripSidebarDivider";
import TripDriverItem from "@/modules/maps/components/ui/SideBar/TripDriverItem.vue";
import TripVehicleItem from "@/modules/maps/components/ui/SideBar/TripVehicleItem.vue";

export default {
  components: {
    TripSidebarDivider,
    TripDriverItem,
    TripVehicleItem
  },

  props:["height"],

  data: () => ({
    sortBy: "",
    items: [{ title: "NAME" }, { title: "DISTANCE" }],
    isMovingClosed: true,
    isStoppedClosed: true,
    isInactiveClosed: true
  }),

  methods: {
    onClose: function(label) {
      switch (label) {
        case "MOVING":
          this.isMovingClosed = !this.isMovingClosed;
          break;
        case "STOPPED":
          this.isStoppedClosed = !this.isStoppedClosed;
          break;
        case "INACTIVE":
          this.isInactiveClosed = !this.isInactiveClosed;
          break;
      }
    },

    onSortBy: function(label) {
      switch (label) {
        case "NAME":
          // todo: call the sortByName getter function
          break;
        case "DISTANCE":
          // todo: call the sortByDistance getter function
          break;

        default:
          // todo: call the sortByName getter function
          break;
      }
      this.sortBy = label;
    }
  },
  computed: {
    movingDevices: function() {
      return this.$store.getters["tracks/getMovingDevices"];
    },

    movingDrivers: function() {
      return this.$store.getters["tracks/getMovingDevices"];
    },
    stoppedDrivers: function() {
      return this.$store.getters["tracks/getStoppedDevices"];
    },
    inactiveDrivers: function() {
      return this.$store.getters["tracks/getInactiveDevices"];
    }
  },

  mounted() {
    this.sortBy = this.items[0].title;
  }
};
</script>

<style scoped>
.SideBarFilter {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  padding: 0px 17px 0px 8px;
}
.scrollSideBar{
  overflow-y: scroll;
}
.tripFilter {
  margin-left: 0px;
  margin-right: -15px;
}

.tripBold {
  font-weight: bolder;
}
</style>
